// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-article-container {
  max-width: 520px;
  margin: 60px auto;
  background: linear-gradient(180deg, #0f172a, #020617);
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
  color: #fff;
}

.edit-article-container h2 {
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 600;
}

.edit-article-container form {
  display: flex;
  flex-direction: column;
}

.edit-article-container input,
.edit-article-container select,
.edit-article-container textarea {
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  background: #020617;
  color: #fff;
  outline: none;
}

.edit-article-container textarea {
  resize: none;
  min-height: 90px;
}

.edit-article-container input:focus,
.edit-article-container select:focus,
.edit-article-container textarea:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
}

.edit-article-container button {
  background: #facc15;
  color: #020617;
  font-weight: 600;
  padding: 12px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}

.edit-article-container button:hover {
  background: #fde047;
}

.button-close{
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Masters/Article Master/EditArticle/EditArticle.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".edit-article-container {\n  max-width: 520px;\n  margin: 60px auto;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  padding: 30px;\n  border-radius: 20px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);\n  color: #fff;\n}\n\n.edit-article-container h2 {\n  margin-bottom: 20px;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.edit-article-container form {\n  display: flex;\n  flex-direction: column;\n}\n\n.edit-article-container input,\n.edit-article-container select,\n.edit-article-container textarea {\n  margin-bottom: 16px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  background: #020617;\n  color: #fff;\n  outline: none;\n}\n\n.edit-article-container textarea {\n  resize: none;\n  min-height: 90px;\n}\n\n.edit-article-container input:focus,\n.edit-article-container select:focus,\n.edit-article-container textarea:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n}\n\n.edit-article-container button {\n  background: #facc15;\n  color: #020617;\n  font-weight: 600;\n  padding: 12px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.edit-article-container button:hover {\n  background: #fde047;\n}\n\n.button-close{\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
